import * as http from './Http'

const SUPER = 'super'

export const _getCompanies = data => http.post(`${SUPER}/get-companies`, data)
export const _getInfoCompanies = data => http.post(`${SUPER}/get-info-companies`, data)
export const _getICabbiCompanies = data => http.post(`${SUPER}/get-icabbi-companies`, data)

export const _saveAdmin = data => http.post(`${SUPER}/save-admin`, data)

export const _list = () => http.get(`${SUPER}/list`)

export const _delete = id => http.del(`${SUPER}/delete/${id}`)

export const _show = id => http.get(`${SUPER}/show/${id}`)

export const status = (user, status) => http.put(`user/${user}/update/status`, status)

export const _update = (id, admin) => http.put(`${SUPER}/update/${id}`, admin)
export const _changePassword = (id, data) => http.put(`${SUPER}/change-password/${id}`, data)

export const _getServices = () => http.get(`${SUPER}/services`)
